import React from 'react'
import { useTranslation } from 'react-i18next'
import { DropOptions } from '../../../../shared/components/forms/drop-options/DropOptions'
import {
  TeamUserChangeStatusForm,
  usePostTeamManagementSendInviteMutation,
  usePostTeamManagementUserChangeStatusMutation,
} from '../../../../app/api'
import { useAppDispatch } from '../../../../app/store/hooks/Redux'
import { showAlert } from '../../../../app/store/reducers/AppSlice'

interface StatusCellProps {
  id: number
  email: string
  role: string
  status: string
}

export const StatusCell = ({ id, email, role, status }: StatusCellProps) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const [updateStatus] = usePostTeamManagementUserChangeStatusMutation()
  const [sendInvite] = usePostTeamManagementSendInviteMutation()

  const options = [
    {
      text: t('pages.team.activate'),
      value: 'active',
      hidden: ['active', 'pending'].includes(status),
    },
    {
      text: t('pages.team.archive'),
      value: 'archived',
      hidden: ['archived'].includes(status),
    },
  ]

  return (
    <div className={'flex items-center gap-[8px]'}>
      <DropOptions
        disabled={role === 'owner'}
        options={options}
        onChange={(value) => {
          updateStatus({
            teamUserChangeStatusForm: { id, status: value as TeamUserChangeStatusForm['status'] },
          })
        }}
      >
        <span
          className={`cursor-pointer rounded-[6px] py-[2px] px-[8px] text-[10px] font-semibold uppercase ${(status === 'pending' || role === 'owner') && 'cursor-default'} ${
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            {
              active: 'bg-success-300 text-success-400',
              pending: 'bg-danger/[.07] text-[#DA5533]',
              archived: 'bg-aqua-300/[.07] text-aqua-300',
            }[status]
          }`}
        >
          {t('pages.team.statuses.' + status)}
        </span>
      </DropOptions>
      {status === 'pending' && (
        <button
          className={'cursor-pointer border-b border-dotted text-[13px] leading-[13px] text-focus'}
          type='button'
          onClick={() =>
            sendInvite({ teamSendInviteForm: { user_id: id } }).then((response: any) => {
              if (response.data?.success) {
                dispatch(
                  showAlert({
                    message: t('pages.team.inviteResent', { email }),
                    type: 'success',
                    timeout: 2000,
                  }),
                )
              }
            })
          }
        >
          {t('pages.team.resendInvitation')}
        </button>
      )}
    </div>
  )
}
